import { useRouteError } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { PageError } from 'src/components/page-state';

// ----------------------------------------------------------------------

function getErrorDetail(error) {
  if (error == null) return '';
  if (typeof error === 'string') return error;
  if (typeof error === 'object' && 'statusText' in error && error.statusText) {
    return String(error.statusText);
  }
  if (error instanceof Error) return error.message;
  try {
    return JSON.stringify(error);
  } catch {
    return 'Unknown error';
  }
}

/**
 * React Router `errorElement` — catches errors thrown in route loaders / lazy chunks / render.
 */
export function RouteErrorView() {
  const error = useRouteError();
  const detail = getErrorDetail(error);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        py: 4,
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <PageError
          title="This page could not be loaded"
          description="Something went wrong while rendering this screen. You can try again or go back to the home page."
          error={import.meta.env.DEV ? detail : undefined}
          onRetry={() => window.location.reload()}
          retryLabel="Reload page"
        />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 3 }} justifyContent="center">
          <Button component={RouterLink} href={paths.root} variant="contained" size="large" fullWidth>
            Go to home
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
